'use client';

import { Typography } from '@/ui';
import { usePathname } from 'next/navigation';
import styles from './WorkLifeToggle.module.css';

export const WorkLifeToggle = () => {
  const pathname = usePathname();
  const isLife = pathname?.startsWith('/life') ?? false;

  return (
    <nav className={styles.switch}>
      <Typography.Link
        href="/"
        className={isLife ? styles.link : styles.active}
      >
        Work
      </Typography.Link>
      <Typography.Link
        href="/life"
        className={isLife ? styles.active : styles.link}
      >
        Life
      </Typography.Link>
    </nav>
  );
};
